import { cn } from '@ctct/summit-core';
import { Command as CommandPrimitive } from 'cmdk';
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react';

/**
 * Wrapper for items in command
 */
const CommandList = forwardRef<
  ElementRef<typeof CommandPrimitive.List>,
  ComponentPropsWithoutRef<typeof CommandPrimitive.List>
>(({ className, ...props }, ref) => (
  <CommandPrimitive.List
    ref={ref}
    className={cn(
      'rds-command-list',
      'r:max-h-[300px] r:overflow-y-auto r:overflow-x-hidden',
      className
    )}
    data-sds-id="command-list"
    {...props}
  />
));

CommandList.displayName = 'CommandList';

export { CommandList };
